import Transform from "@ember-data/serializer/transform";
import type { SerializedCompoundSurveyFrequency } from "parog-web/models/compound-survey-frequency";
import CompoundSurveyFrequency from "parog-web/models/compound-survey-frequency";

export default class CompoundSurveyFrequenciesTransform extends Transform {
  override deserialize(
    serialized: SerializedCompoundSurveyFrequency[]
  ): CompoundSurveyFrequency[] {
    return serialized.map(
      item => new CompoundSurveyFrequency({ ...item, enabled: true })
    );
  }

  override serialize(
    deserialized: CompoundSurveyFrequency[]
  ): SerializedCompoundSurveyFrequency[] {
    return deserialized.map(freq => freq.serialize());
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "compound-survey-frequencies": CompoundSurveyFrequenciesTransform;
  }
}
